import '../../styles/Navbar.css';

import {
	AppBar,
	Box,
	Container,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	Toolbar,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../atoms/Button';
import MenuIcon from '@mui/icons-material/Menu';
import UserProfile from './UserProfile';
import hamburgerIcon from '../../assets/hamburger.svg';
import { logger } from '../../utils/logger';
import { selectTest } from '../../store/testSelectionSlice';
import { useModal } from '../../context.js/ModalContext';
import { useNavigate } from 'react-router-dom';

const Navbar = () =>
	// { openLoginModal, openSignUpModal, handleOverlayClick }
	{
		const [isOpen, setIsOpen] = useState(false);
		const [activePath, setActivePath] = useState(window.location.pathname);
		const { isAuthenticated } = useSelector((state) => state.userDetails);
		const [isExamDropdownOpen, setExamDropdownOpen] = useState(false);
		const [state, setState] = useState(false);
		const navigate = useNavigate();
		const dispatch = useDispatch();
		const { openLoginModal, openSignUpModal } = useModal();

		// Add useEffect to handle clicks outside
		useEffect(() => {
			const handleClickOutside = (event) => {
				const menu = document.querySelector('.nav-menu');
				const hamburger = document.querySelector('.hamburger');

				if (
					isOpen &&
					menu &&
					!menu.contains(event.target) &&
					!hamburger.contains(event.target)
				) {
					setIsOpen(false);
				}
			};

			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		}, [isOpen]);

		// Create wrapped handlers for login/signup
		const handleLoginClick = (e) => {
			setState(false); // Close the menu
			openLoginModal(); // Call the original handler
		};

		const handleSignUpClick = (e) => {
			setState(false); // Close the menu
			openSignUpModal(); // Call the original handler
		};

		const handleNavigation = (event, path, action = null) => {
			event.preventDefault(); // Prevent default navigation

			if (
				!isAuthenticated &&
				(path === '/knowledge_concept' || path === '/exam' || path === '/SFT')
			) {
				logger.log('User not authenticated. Opening login modal...');
				openLoginModal();
				return;
			}

			// If authenticated or not a protected route, proceed with navigation
			setActivePath(path);
			if (action) action();
			if (path === '/exam') {
				dispatch(selectTest('SAT'));
			} else if (path === '/SFT') {
				dispatch(selectTest('SFT'));
			}
			navigate(path);
		};

		const list = () => (
			<Box
				sx={{
					backgroundColor: '#0a0b7e',
					color: 'white',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
				}}
			>
				<Box
					sx={{
						width: 250,
					}}
					role="presentation"
					onClick={() => setState(false)}
					onKeyDown={() => setState(false)}
				>
					<List>
						<ListItem key={'Home'}>
							<ListItemButton onClick={(e) => handleNavigation(e, '/')}>
								<ListItemText primary={'Home'} />
							</ListItemButton>
						</ListItem>
						<Divider
							sx={{ marginX: '1rem', backgroundColor: 'white', borderBottom: 1 }}
						/>
						<ListItem key={'Knowledge Concept'}>
							<ListItemButton
								onClick={(e) => handleNavigation(e, '/knowledge_concept')}
							>
								<ListItemText primary={'Knowledge Concept'} />
							</ListItemButton>
						</ListItem>
						<Divider
							sx={{ marginX: '1rem', backgroundColor: 'white', borderBottom: 1 }}
						/>
						{/* <ListItem key={'Exam'}>
							<ListItemButton onClick={(e) => handleNavigation(e, '/exam')}>
								<ListItemText primary={'Exam'} />
							</ListItemButton>
							<List>
							this bellow has to be commented
							<ListItemButton onClick={(e) => handleNavigation(e, "/exam")}>
								<ListItemText primary={"SAT"} />
							</ListItemButton>
						</List>
						</ListItem> 
						<Divider
							sx={{ marginX: '1rem', backgroundColor: 'white', borderBottom: 1 }}
						/>*/}
						{/* <ListItem key={"SAT"} sx={{ marginLeft: "1rem" }}>
							<ListItemButton
								onClick={(e) => handleNavigation(e, "/exam")}
								sx={{ fontSize: "14px" }}>
								<ListItemText
									primary={"SAT"}
									sx={{ "& .MuiTypography-body1": { fontSize: "14px" } }}
								/>
							</ListItemButton>
						</ListItem>
						<Divider
							sx={{
								marginLeft: "2rem",
								marginRight: "1rem",
								backgroundColor: "white",
								borderBottom: 1,
							}}
						/>
						<ListItem key={"SFT"} sx={{ marginLeft: "1rem" }}>
							<ListItemButton
								onClick={(e) => handleNavigation(e, "/SFT")}
								sx={{ fontSize: "14px" }}>
								<ListItemText
									primary={"SFT"}
									sx={{ "& .MuiTypography-body1": { fontSize: "14px" } }}
								/>
							</ListItemButton>
						</ListItem> */}
						<Divider
							sx={{
								marginLeft: '2rem',
								marginRight: '1rem',
								backgroundColor: 'white',
								borderBottom: 1,
							}}
						/>
						<ListItem key={'Blog'}>
							<ListItemButton onClick={(e) => handleNavigation(e, '/blog')}>
								<ListItemText primary={'Blog'} />
							</ListItemButton>
						</ListItem>
						<Divider
							sx={{ marginX: '1rem', backgroundColor: 'white', borderBottom: 1 }}
						/>
						<ListItem key={'FAQ'}>
							<ListItemButton onClick={(e) => handleNavigation(e, '/faq')}>
								<ListItemText primary={'FAQ'} />
							</ListItemButton>
						</ListItem>
						<Divider
							sx={{ marginX: '1rem', backgroundColor: 'white', borderBottom: 1 }}
						/>
					</List>
				</Box>
				<Box sx={{ width: 250 }}>
					{!isAuthenticated ? (
						<ul className="auth-buttons">
							<Button
								style={{ marginRight: '8px' }}
								className="sign-up-button"
								label="Sign Up"
								onClick={(e) => handleSignUpClick(e)}
							/>
							<Button
								className="log-in-button"
								label="Login"
								onClick={handleLoginClick}
							/>
						</ul>
					) : (
						<ul>
							<UserProfile
								handleNavigation={handleNavigation}
								setState={setState}
								setActivePath={setActivePath}
							/>
						</ul>
					)}
				</Box>
			</Box>
		);

		return (
			<AppBar position="sticky" sx={{ backgroundColor: '#0a0b7e' }}>
				<Container maxWidth="xl">
					<Toolbar>
						<Typography
							variant="h6"
							noWrap
							component="a"
							href="/"
							onClick={() => setActivePath('/')}
							sx={{
								mr: 10,
								// display: { xs: "none", md: "flex" },
								fontFamily: 'monospace',
								fontWeight: 700,
								letterSpacing: '.3rem',
								color: 'inherit',
								textDecoration: 'none',
							}}
						>
							PREPITUS
						</Typography>
						<Box
							className="nav-menu active"
							sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
						>
							<ul className="nav-links">
								<li>
									<a
										className={`nav-link ${activePath === '/' ? 'active' : ''}`}
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
										href="/"
										onClick={() => setActivePath('/')}
										//onClick={(event) => handleNavigation(event, "/")}
									>
										Home
									</a>
								</li>
								<li>
									<a
										className={`nav-link ${
											activePath === '/knowledge_concept' ? 'active' : ''
										}`}
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
										href="/knowledge_concept"
										onClick={(event) =>
											handleNavigation(event, '/knowledge_concept')
										}
									>
										Knowledge Concept
									</a>
								</li>
								<li
									className="nav-dropdown"
									onMouseEnter={() => setExamDropdownOpen(true)}
									onMouseLeave={() => setExamDropdownOpen(false)}
								>
									<a
										className={`nav-link ${
											activePath === '/exam' ? 'active' : ''
										}`}
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
										href="/exam"
										//  onClick={() =>{
										//    toggleExamPage();
										//   setActivePath('/exam')}}
										onClick={(event) => handleNavigation(event, '/exam')}
									>
										Exam
									</a>
									{
										<ul className="exam-dropdown-menu">
											<li style={{ margin: 0, padding: '0 15px' }}>
												<a
													href="/exam"
													onClick={(event) =>
														handleNavigation(event, '/exam')
													}
												>
													SAT
												</a>
											</li>
											<li style={{ margin: 0, padding: '0 15px' }}>
												<a
													href="/SFT"
													onClick={(event) =>
														handleNavigation(event, '/SFT')
													}
												>
													SFT
												</a>
											</li>
										</ul>
									}
								</li>
								<li>
									<a
										className={`nav-link ${
											activePath === '/blog' ? 'active' : ''
										}`}
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
										href="/blog"
										onClick={(event) => handleNavigation(event, '/blog')}
									>
										Blog
									</a>
								</li>
								<li>
									<a
										className={`nav-link ${
											activePath === '/faq' ? 'active' : ''
										}`}
										style={{
											color: 'white',
											textDecoration: 'none',
										}}
										href="/faq"
										onClick={() => setActivePath('/faq')}
									>
										FAQ
									</a>
								</li>
							</ul>
						</Box>
						<Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
							{!isAuthenticated ? (
								<ul className="auth-buttons">
									<Button
										style={{ marginRight: '8px' }}
										className="sign-up-button"
										label="Sign Up"
										onClick={handleSignUpClick}
									/>
									<Button
										className="log-in-button"
										label="Login"
										onClick={handleLoginClick}
									/>
								</ul>
							) : (
								<ul>
									<UserProfile
										handleNavigation={handleNavigation}
										setState={setState}
										setActivePath={setActivePath}
									/>
								</ul>
							)}
						</Box>
						<Box
							sx={{
								flexGrow: 1,
								display: { xs: 'flex', md: 'none' },
								justifyContent: 'end',
							}}
						>
							<IconButton onClick={() => setState((prev) => !prev)}>
								<MenuIcon fontSize="large" sx={{ color: 'white' }} />
							</IconButton>
							<Drawer
								anchor="right"
								open={state}
								onClose={() => setState(false)}
								sx={{
									marginTop: '',
									[`& .MuiDrawer-paper`]: {
										boxSizing: 'border-box',
										backgroundColor: 'transparent',
									},
								}}
							>
								{/* <Toolbar sx={{ backgroundColor: "transparent", zIndex: "-1000" }} /> */}
								{list()}
							</Drawer>
						</Box>
					</Toolbar>
				</Container>
			</AppBar>
		);
	};

export default Navbar;
